import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import { __decorate } from "tslib";
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import UserCell from '@/components/platform/copySpeach/UserCell.vue';
import store from '@/store';
import { debounce } from 'lodash';
import { AUTHORS_LIST, RESET_AUTHORS_LIST } from '@/store/actions/speach';
import { v4 as uuidv4 } from "uuid";
import InfiniteLoading from 'vue-infinite-loading';
var SearchUser = /*#__PURE__*/function (_Vue) {
  function SearchUser() {
    var _this;
    _classCallCheck(this, SearchUser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SearchUser, [].concat(args));
    _defineProperty(_this, "platform", void 0);
    _defineProperty(_this, "value", void 0);
    _defineProperty(_this, "placeholder", void 0);
    _defineProperty(_this, "realValue", null);
    _defineProperty(_this, "searchAuthorsInfiniteLoader", null);
    _defineProperty(_this, "infiniteLoaderID", uuidv4());
    _defineProperty(_this, "isFetching", false);
    _defineProperty(_this, "textSearched", '');
    _defineProperty(_this, "currentPage", 1);
    return _this;
  }
  _inherits(SearchUser, _Vue);
  return _createClass(SearchUser, [{
    key: "mounted",
    value: function mounted() {
      this.initInfiniteLoader();
      this.setTextSearchedAndRealValue();
    }
  }, {
    key: "initInfiniteLoader",
    value: function initInfiniteLoader() {
      var _this2 = this;
      this.searchAuthorsInfiniteLoader = debounce(function (state) {
        if (_this2.authorsCount > _this2.authors.length) {
          _this2.infiniteSearchAuthors(++_this2.currentPage, true, state);
        } else {
          _this2.completeState(state);
        }
      }, 250);
    }
  }, {
    key: "authors",
    get: function get() {
      return store.getters.authors(this.platform);
    }
  }, {
    key: "authorsCount",
    get: function get() {
      return store.getters.totalNumberAuthors(this.platform);
    }
  }, {
    key: "select",
    value: function select(option) {
      this.realValue = option;
      this.onChangeValue();
    }
  }, {
    key: "onChangeValue",
    value: function onChangeValue() {
      var _this$realValue;
      this.textSearched = (_this$realValue = this.realValue) === null || _this$realValue === void 0 ? void 0 : _this$realValue.email;
      this.$emit('userChange', this.realValue);
      this.resetCurrentPage();
    }
  }, {
    key: "onClearSelection",
    value: function onClearSelection() {
      this.resetSearchInput();
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      var _this$realValue2;
      this.textSearched = (_this$realValue2 = this.realValue) === null || _this$realValue2 === void 0 ? void 0 : _this$realValue2.email;
    }
  }, {
    key: "onChangePropValue",
    value: function onChangePropValue() {
      this.setTextSearchedAndRealValue();
    }
  }, {
    key: "resetSearchInput",
    value: function resetSearchInput() {
      this.realValue = null;
      this.textSearched = '';
      this.onChangeValue();
    }
  }, {
    key: "setTextSearchedAndRealValue",
    value: function setTextSearchedAndRealValue() {
      var _this$value;
      this.realValue = this.value;
      this.textSearched = ((_this$value = this.value) === null || _this$value === void 0 ? void 0 : _this$value.email) || '';
    }
  }, {
    key: "searchAuthors",
    value: function searchAuthors(query) {
      var _this$realValue3;
      if (query || this.textSearched !== ((_this$realValue3 = this.realValue) === null || _this$realValue3 === void 0 ? void 0 : _this$realValue3.email)) {
        this.textSearched = query;
      }
      this.resetCurrentPage();
      this.resetAuthorsList();
      this.refreshInfiniteLoaderId();
      this.infiniteSearchAuthors(this.currentPage);
    }
  }, {
    key: "refreshInfiniteLoaderId",
    value: function refreshInfiniteLoaderId() {
      this.infiniteLoaderID = uuidv4();
    }
  }, {
    key: "infiniteSearchAuthors",
    value: function infiniteSearchAuthors(page, append, state) {
      var _this3 = this;
      this.isFetching = true;
      this.searchAuthorsImpl(page, append).then(function () {
        if (state) {
          if (_this3.authorsCount > _this3.authors.length) {
            state.loaded();
          } else {
            _this3.completeState(state);
          }
        }
      }).catch(function () {
        _this3.completeState(state);
      }).finally(function () {
        return _this3.isFetching = false;
      });
    }
  }, {
    key: "completeState",
    value: function completeState(state) {
      state === null || state === void 0 || state.complete();
      this.resetCurrentPage();
    }
  }, {
    key: "resetCurrentPage",
    value: function resetCurrentPage() {
      this.currentPage = 1;
    }
  }, {
    key: "searchAuthorsImpl",
    value: function searchAuthorsImpl() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var append = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return store.dispatch(AUTHORS_LIST, {
        platformID: this.platform,
        author: this.textSearched,
        page: page,
        append: append
      });
    }
  }, {
    key: "resetAuthorsList",
    value: function resetAuthorsList() {
      store.dispatch(RESET_AUTHORS_LIST, this.platform);
    }
  }]);
}(Vue);
__decorate([Prop({
  default: ''
})], SearchUser.prototype, "platform", void 0);
__decorate([Prop({
  default: null
})], SearchUser.prototype, "value", void 0);
__decorate([Prop({
  default: "User email"
})], SearchUser.prototype, "placeholder", void 0);
__decorate([Watch('value')], SearchUser.prototype, "onChangePropValue", null);
__decorate([Watch('platform')], SearchUser.prototype, "resetSearchInput", null);
SearchUser = __decorate([Options({
  components: {
    UserCell: UserCell,
    InfiniteLoading: InfiniteLoading
  }
})], SearchUser);
export default SearchUser;